
    <div class="login-card login-dark">
        <div>
            <div>
                <a class="logo"  routerLink='/'>
                    <img class="image-logo for-light" src="assets/images/logo/logo.png" alt="looginpage">
<!--                    <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage">-->
                    <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage">
                </a>
            </div>
            <div class="login-main">
                <form class="theme-form" [formGroup]="userForm" (ngSubmit)="onSubmit()">
                    <h4>Créez votre compte</h4>
                    <p>Saisissez vos informations personnelles pour créer un compte</p>
                    <div class="form-group">

                        <label class="col-form-label pt-0">Nom d'utilisateur</label>
                        <input class="form-control" type="text" placeholder="" formControlName="username" required>
                      </div>
                      <div class="form-group">
                          <label class="col-form-label">Email Address</label>
                          <input class="form-control" type="email" required="true" placeholder="app@yourmail.com" formControlName="email">
                          <!--  <div *ngIf="userForm.get('email').invalid && userForm.get('email').touched" class="alert alert-danger">
                                invalid.
                            </div>
                            -->
                        </div>
<!--                        <div class="form-group">-->
<!--                            <label class="col-form-label">Mot de passe</label>-->
<!--                            <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]" placeholder="*********" formControlName="password" required>-->
<!--                            <div class="show-hide" (click)="showPassword()" *ngIf="!show"> <i class="fa fa-eye"></i></div>-->
<!--                            <div class="show-hide" (click)="showPassword()" *ngIf="show"><i class="fa fa-eye-slash"></i></div>-->
<!--                            &lt;!&ndash;  <div *ngIf="userForm.get('password').invalid && userForm.get('password').touched" class="alert alert-danger">-->
<!--                                  invalid.-->
<!--                              </div>-->
<!--                              &ndash;&gt;-->
<!--                          </div>-->

                    <div class="form-group position-relative">
                        <label class="col-form-label">Mot de passe</label>
                        <div class="position-relative">
                            <input class="form-control"
                                   [type]="show ? 'text' : 'password'"
                                   name="login[password]"
                                   placeholder="*********"
                                   formControlName="password"
                                   (input)="validatePassword()"
                                   required>

                            <div class="position-absolute top-50 end-0 translate-middle-y pe-3" (click)="showPassword()">
                                <i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </div>
                        </div>

                        <!-- Messages d'erreur priorisés -->
                        <div class="alert alert-danger mt-2" *ngIf="getPriorityError() as error">
                            <ng-container [ngSwitch]="error">
                                <div *ngSwitchCase="'required'">
                                    Le mot de passe est requis.
                                </div>
                                <div *ngSwitchCase="'minLength'">
                                    Doit contenir au moins {{ minLength }} caractères ({{ passwordLength }}/{{ minLength }}).
                                </div>
                                <div *ngSwitchCase="'uppercase'">
                                    Doit contenir au moins une lettre majuscule.
                                </div>
                                <div *ngSwitchCase="'lowercase'">
                                    Doit contenir au moins une lettre minuscule.
                                </div>
                                <div *ngSwitchCase="'digit'">
                                    Doit contenir au moins un chiffre.
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="form-group">
                              <label class="col-form-label">Confirmer</label>
                              <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="confirmPassword" placeholder="Confirmez le mot de passe" required>
                              <div class="show-hide" (click)="showPassword()" *ngIf="!show"><i class="fa fa-eye"></i></div>
                              <div class="show-hide" (click)="showPassword()" *ngIf="show"><i class="fa fa-eye-slash"></i></div>
                        <div class="alert alert-danger mt-2" *ngIf="userForm.get('confirmPassword')?.touched && userForm.get('confirmPassword')?.value !== userForm.get('password')?.value">
                            Le mot de passe de confirmation ne correspond pas.
                        </div>

                              <!--  <div *ngIf="userForm.get('confirmPassword').invalid && userForm.get('confirmPassword').touched && userForm.get('confirmPassword')!==userForm.get('password')" class="alert alert-danger">
                                    {{userForm.get('confirmPassword').value}}
                                </div>
                                -->
                            </div>
                    <div class="form-group">
<!--                                <div *ngIf="isloading">-->
<!--                                    <div class="spinner-border text-primary" role="status">-->
<!--                                        <span class="visually-hidden">Loading...</span>-->
<!--                                    </div>-->
<!--                                </div>-->

                                    <button class="btn btn-primary d-block w-100" [disabled]="userForm.invalid" type="submit">Créer un compte</button>
                                <ngx-spinner
                                        bdColor="rgba(51,51,51,0.8)"
                                        size="medium"
                                        color="#fff"
                                        type="ball-scale-multiple"
                                >
                                </ngx-spinner>

                            </div>



                       </form>
                        <!--
                        <h6 class="mt-4 float-center">Ou inscrivez-vous avec</h6>
                        <div class="social">
                            <div class="btn-showcase">
                                <a class="btn btn-light" href="https://www.linkedin.com/login" target="_blank">
                                    <app-feather-icons [icon]="'linkedin'" class="txt-linkedin"></app-feather-icons> LinkedIn
                                </a>
                                <a class="btn btn-light" href="https://twitter.com/login?lang=en" target="_blank">
                                    <app-feather-icons [icon]="'twitter'" class="txt-twitter"></app-feather-icons>twitter
                                </a>
                                <a class="btn btn-light" href="https://www.facebook.com/" target="_blank">
                                    <app-feather-icons [icon]="'facebook'" class="txt-fb"></app-feather-icons>facebook
                                </a>
                            </div>
                        </div>
                        -->
                <p class="mt-4 mb-4">Vous avez déjà un compte?<a class="ms-2" [routerLink]="'/authentication/login/simple'">Se connecter</a></p>

                <a class="btn btn-primary float-start mb-2" (click)="back()"> <i class="fa fa-arrow-left"> </i> Précédent</a>

            </div>
        </div>

    </div>

